import { getLoanStatementSummaries } from 'APIs/loan.statement/loanstatement';
import HeaderTitle from 'Components/HeaderTitle/HeaderTitle';
import { Content } from 'Constants/styles';
import { LpBox } from 'Constants/styles';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import LoanStatementManualPayment from './LoanStatementManualPayment';
import TriggerLoanStatementCreation from './TriggerLoanStatementCreation';
import { BlueBtn, Flex } from './styles';

const LoanStatements = () => {
  const { apiAprilBaseUri } = useSelector((state: ReduxStateType) => ({
    apiAprilBaseUri: state.apiAprilBaseUri,
  }));

  const [showManualPaymentModal, setShowManualPaymentModal] = useState<boolean>(false);
  const [showStatementCreationModal, setShowStatementCreationModal] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        await getLoanStatementSummaries(apiAprilBaseUri, { currency: 'AUD' });
      } catch (error) {
        console.error(error);
      }
    })();
  }, [apiAprilBaseUri]);

  return (
    <div className="mb-4">
      <HeaderTitle title="Loan Statements" />
      <Content>
        <LpBox>
          <h3>Administer Loan Statement</h3>
          <Flex>
            <BlueBtn onClick={() => setShowManualPaymentModal(true)}>Manual Payment</BlueBtn>
            <BlueBtn onClick={() => setShowStatementCreationModal(true)}>Create Loan Statement</BlueBtn>
          </Flex>
        </LpBox>
        <LoanStatementManualPayment showModal={showManualPaymentModal} setShowModal={setShowManualPaymentModal} />
        <TriggerLoanStatementCreation
          showModal={showStatementCreationModal}
          setShowModal={setShowStatementCreationModal}
        />
      </Content>
    </div>
  );
};

export default LoanStatements;
